export const CELL_HEIGHT = 30;
export const CELL_MARGIN_BOTTOM = 3;
export const CELL_TOTAL = CELL_HEIGHT + CELL_MARGIN_BOTTOM;
export const MAX_VISIBLE_DAYS = 7;
